import { isBoolean, isNil } from 'lodash-es'
import { TourKey } from '@/store/tour'
import { UserMetadata } from '@/types/schema/user-metadata'

// 如 tour 本身需要是否已讀的獨立狀態，需擴充 TOUR_KEY_TO_METADATA_KEY_MAP
// 否則會統一使用 userMetadata.completed_onboarding
const TOUR_KEY_TO_METADATA_KEY_MAP: {
  [key in TourKey]?: keyof UserMetadata
} = {
  'predictive-report': 'is_predictive_report_tour_read',
}

const checkTourRead = (
  tourKey: TourKey,
  userMetadata?: UserMetadata,
): boolean => {
  if (!userMetadata) {
    return false
  }

  const metadataKey = TOUR_KEY_TO_METADATA_KEY_MAP[tourKey]
  if (isNil(metadataKey)) {
    return userMetadata.completed_onboarding
  }

  const tourReadStatus = userMetadata[metadataKey]
  if (!isBoolean(tourReadStatus)) {
    return userMetadata.completed_onboarding
  }

  return tourReadStatus
}

export default checkTourRead
